import { render } from "./UnCryptoGroupBuyAvatarGroup.vue?vue&type=template&id=55cc5e56&scoped=true"
import script from "./UnCryptoGroupBuyAvatarGroup.vue?vue&type=script&lang=js"
export * from "./UnCryptoGroupBuyAvatarGroup.vue?vue&type=script&lang=js"

import "./UnCryptoGroupBuyAvatarGroup.vue?vue&type=style&index=0&id=55cc5e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cc5e56"]])

export default __exports__